module.exports = __webpack_public_path__ + "static/media/61KDlr8BRvL._SL1200_.a65dbebb.jpg";